type MailReceivers = {
  id: string;
  email?: string;
};

export const selfNotificationSettings = {
  mailActive: true,
  mailReceivers: [],
  mailSenderName: 'Elfsight',
  mailSubject: 'Elfsight: New Form Submission',
  mailTemplate:
    '<p>This message was sent from website [page-url]:</p><br>[form-data]',
  mailCC: [],
  mailBCC: [],
  mailReplyTo: '[email]',
  mailEI:
    'eyJpdiI6IjZSXC8yMEN6d0pOaDYrV2hUdTB3WURRPT0iLCJ2YWx1ZSI6IjBaYld4QW5IaEVxaDRoY1BlY3o5Tk9FWWtqMHBsd1gwYXU4SVM3Q1wvZjZicG1mMERSRVI4dElTak9xTElrN3ZcL05kU1JJZDVzc0Y5MmdRMlVlUG51ejQ0SUtGVmIxNzI4Q0ZBaTFlaFIrOTU1MGtFTWhFaFwva1wvMDRhU2NQSm1jclc0M3QyRFBkbFUrTlRVMVJOUVZucFlYanhIWFNxNEtTZE9XQXIyYTZ0TUVxbmRMUk9hM1hTWitcL2UyVGxOb1JFcTJuQ2hXUFhlcUJNeGFFaDVmODVFc0xFRFpwRE9GTkVlR1lPanhXTnF5QTNiYWZkbXZxT1lWQTFkaUE1VjFlVTkyRWtvb3JtRThQZDR1NXpNUWtYbkJjQ3YyNm5jbGpmc2RETjFrWjF0U3M9IiwibWFjIjoiNDUwNTg2MjY5Y2Q5YTc4Mzc5MGNlMjkyZWMxY2U5YWYyYzk3NGY1Y2E5MjM0ODM0NTBjYTFkODExY2I3ZDBiOSJ9'
};

export type SelfNotificationSettings = typeof selfNotificationSettings & {
  mailReceivers: MailReceivers[];
  mailCC: MailReceivers[];
  mailBCC: MailReceivers[];
};
